import moment from "moment-timezone";

export const formatDateTime = (value: string) => {
	return moment(value.replace("[UTC]", "")).tz(moment.tz.guess()).format("DD.MM.YYYY HH:mm");
};
